import React, { SVGProps } from 'react'

export const PatientAlertIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
    <mask
      id="a"
      width={24}
      height={24}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
    >
      <path fill="#D9D9D9" d="M0 0h24v24H0z" />
    </mask>
    <g mask="url(#a)">
      <path
        fill="#000"
        fillOpacity={0.8}
        d="M9.383 11.55c1.172 0 1.617.1 1.617.1s-.496.554-.7.95c-.17.33-.3.9-.3.9s-1.957.045-3.117.3c-1.388.306-3.782 1.19-3.833 1.7C2.95 16.5 3 17 3 17h6.883s.119.624.267 1c.164.415.55 1 .55 1H1v-3.3c0-2.702 5.21-4.15 8.383-4.15Z"
      />
      <path
        fill="#000"
        fillOpacity={0.8}
        fillRule="evenodd"
        d="M9.55 8.5a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5Zm0 2a4.25 4.25 0 1 0 0-8.5 4.25 4.25 0 0 0 0 8.5Z"
        clipRule="evenodd"
      />
      <path
        fill="#B31B32"
        fillRule="evenodd"
        d="M16.5 21.5a6 6 0 1 0 0-12 6 6 0 0 0 0 12Zm-.857-9.428h1.73l-.346 4.5H15.99l-.346-4.5Zm1.73 5.991a.866.866 0 1 1-1.73 0 .866.866 0 0 1 1.73 0Z"
        clipRule="evenodd"
      />
    </g>
  </svg>
)
